module.exports = __webpack_public_path__ + "static/media/owner1_logo.aed7d932.png";